<template>
	<v-container fluid pa-0 my-3>
		<div class="projects-panel">
			<div class="pm-header">
				<div class="d-flex align-center" style="gap: 12px;">
					<div class="pm-avatar">
						<v-icon color="white" size="20">mdi-view-list-outline</v-icon>
					</div>
					<div>
						<p class="pm-title mb-0">Proyectos</p>
						<p class="pm-subtitle mb-0">Configura los módulos habilitados por proyecto</p>
					</div>
				</div>
			</div>

			<div class="projects-body">
				<div class="info-banner">
					<v-icon size="18" color="#2D4B95" class="mr-2">mdi-information-outline</v-icon>
					<span>Desde este listado puedes gestionar los módulos habilitados para cada proyecto. Usa el botón <b>Módulos</b> junto a cada proyecto para activar o desactivar las funcionalidades disponibles.</span>
				</div>

				<div v-if="loading" class="d-flex justify-center py-8">
					<v-progress-circular indeterminate color="#2D4B95" size="28" width="2" />
				</div>

				<template v-else>
					<div class="project-row" v-for="project in projects" :key="project.id">
						<v-avatar v-if="project.project_image" size="42" class="flex-shrink-0">
							<v-img :src="project.project_image" />
						</v-avatar>
						<v-avatar v-else size="42" color="#2D4B95" class="flex-shrink-0">
							<span class="white--text font-weight-bold" style="font-size: 15px;">{{ firstLetter(project.name) }}</span>
						</v-avatar>

						<div class="project-info">
							<p class="project-name">{{project.name}}</p>
							<p class="project-description">{{project.description || 'Sin descripción'}}</p>
						</div>

						<div class="flex-shrink-0">
							<ProjectModulesConfigModal :project="project" @updated="fetchProjects" />
						</div>
					</div>

					<div v-if="!projects.length" class="text-center py-8" style="color: #8896b3; font-size: 13px;">
						No hay proyectos disponibles.
					</div>
				</template>
			</div>
		</div>
	</v-container>
</template>

<script>
import { getProjects } from '@/helpers/api/admin'
import ProjectModulesConfigModal from './ProjectModulesConfigModal'

export default {
	name: 'ProjectModulesList',
	components: {ProjectModulesConfigModal},
	data: () => ({
		loading: false,
		projects: []
	}),
	mounted(){
		this.fetchProjects()
	},
	methods: {
		async fetchProjects(){
			this.loading = true
			try{
				const projects = await getProjects()
				if(projects.code == 200){
					this.projects = projects.projects
				}
			} finally {
				this.loading = false
			}
		},
		firstLetter(name){
			return name ? name.charAt(0).toUpperCase() : '?'
		}
	}
};
</script>

<style scoped>
	.info-banner{
		display: flex;
		align-items: flex-start;
		background: #eef2fb;
		border: 1px solid #dbe2f2;
		border-radius: 10px;
		padding: 11px 14px;
		margin-bottom: 16px;
		font-size: 12.5px;
		color: #4a5a80;
		line-height: 1.5;
	}
	.projects-panel{
		background: #ffffff;
		border: 1px solid #ebeef4;
		border-radius: 12px;
		overflow: hidden;
	}
	.pm-header{
		background-color: #1C3A7A;
		padding: 16px 20px;
		display: flex;
		align-items: center;
	}
	.pm-avatar{
		width: 38px;
		height: 38px;
		border-radius: 50%;
		background: rgba(255, 255, 255, 0.15);
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
	}
	.pm-title{font-size: 14px; font-weight: 400; color: #ffffff;}
	.pm-subtitle{font-size: 11px; color: rgba(255, 255, 255, 0.6);}
	.projects-body{padding: 20px 24px 8px;}
	.project-row{
		display: flex;
		align-items: center;
		gap: 14px;
		padding: 12px 16px;
		border-radius: 10px;
		background: #ffffff;
		border: 1px solid #ebeef4;
		box-shadow: 0 1px 3px rgba(45,75,149,0.06);
		margin-bottom: 10px;
		transition: box-shadow 0.15s ease, border-color 0.15s ease;
	}
	.project-row:hover{
		box-shadow: 0 3px 10px rgba(45,75,149,0.1);
		border-color: #dbe2f2;
	}
	.project-row:last-child{
		margin-bottom: 0;
	}
	.project-info{
		flex: 1;
		min-width: 0;
	}
	.project-name{
		margin: 0;
		font-size: 13.5px;
		font-weight: 600;
		color: #2D4B95;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.project-description{
		margin: 2px 0 0;
		color: #8896b3;
		font-size: 12px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
</style>